import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Mousewheel, Pagination } from "swiper";
import Image from "components/image";
import Link from "components/link";
import arrow from "src/assets/images/aroow.svg";
import * as styles from "./style.mod.scss";

const BigImageSlider = ({ data }) => {

  var settings = {
    spaceBetween: 25,
    slidesPerView: 2.5,
    slidesPerGroup: 1,
    modules: [Mousewheel, Pagination],
    mousewheel: {
      enabled: true,
      forceToAxis: true,
    },
    speed: 600,
    pagination: { clickable: true },
    breakpoints: {
      767: {
        slidesPerView: 3,
        spaceBetween: 10,
        pagination: false,
      },
      992: {
        slidesPerView: 3.4,
        spaceBetween: 15,
      },
      1025: {
        spaceBetween: 20,
        slidesPerView: 2.3,
      },
      1270: {
        spaceBetween: 25,
        slidesPerView: 2.3,
      }
    },
  };

  return (
    <div className={styles.bigImageSlider}>
      <div className={styles.leftImage}>
        <Image image={data?.bigImg} alt={data?.bigImg?.alt} />
      </div>
      <div className={styles.rightImages} style={{ backgroundColor: data?.bgColor && data?.bgColor?.hex }}>
        {data?.title &&
          <h3 className={styles.mainTitle}>{data?.title}</h3>}
        <div className={styles.smallImages}>
          {data?.button?.btnTitle &&
            <Link to={data?.button?.btnLink} className={styles.buttonTitle}>{data?.button?.btnTitle}<img className={styles.svgArrow} src={arrow} /></Link>}
          <div className={styles.imagesContainer}>
            <Swiper {...settings}>
              {data?.smallImages?.map((singleItem, i) => (
                <SwiperSlide key={i}>
                  <div key={i} className={styles.singleImgItem}>
                    <div className={styles.reviewsCardContainer} >
                      {singleItem?.image &&
                        <Link to={singleItem?.link}>
                          <div className={styles.productImg}>
                            <Image image={singleItem?.image} alt={singleItem.image?.alt} style={{ opacity: 1 }} />
                          </div> </Link>}
                      {singleItem?.title &&
                        <p className={styles.prodTitle}>{singleItem?.title}</p>}
                      {singleItem?.subtitle &&
                        <p className={styles.prodSubtitle}>{singleItem?.subtitle}</p>}
                    </div>
                  </div>
                </SwiperSlide>
              ))}
            </Swiper>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BigImageSlider;